import { dataAccessEnvironment } from './data-access-environment';

/**
 * Authorization header for APIs that use an authToken from AuthWS
 */
export class TidAuthHeaders {
  readonly Authorization: string;

  constructor() {
    this.Authorization = `Bearer ${dataAccessEnvironment.tidJwt}`;
  }
}
